const {
  paramStore,
} = require('../../../../../../../stores');
export const bankAccountId$ = paramStore('id');
export const accountType$ = paramStore('type');
